/**
 * 菜单管理
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
	// 定义获取菜单列表的异步方法，参数keyId默认为空
	// 发起GET请求获取指定父级ID下的菜单列表
	async getMenuList(keyId='') {
		return request(api.comm.MENU + "?parentId=" + keyId, METHOD.GET);
	},
	async delMenu(keyId) {
		return request(api.comm.MENU + "/" + keyId, METHOD.DELETE);
	},
	async getFormDetail(keyId) {
		return request(api.comm.MENU + '/' + keyId, METHOD.GET);
	},
	async saveFormDetail(result) {
		return request(api.comm.MENU, METHOD.POST, result);
	}
}

export default {dataApi}